/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Private Flags API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Rule in a flag in a project.
 * @export
 * @interface RuleView
 */
export interface RuleView {
    /**
     * System generated Unique ID of the rule
     * @type {number}
     * @memberof RuleView
     */
    readonly id: number;
    /**
     * System generated Unique ID of the project
     * @type {number}
     * @memberof RuleView
     */
    readonly project_id: number;
    /**
     * If the underlying Rule and Ruleset are both enabled
     * @type {boolean}
     * @memberof RuleView
     */
    readonly enabled: boolean;
    /**
     * is the rule archived
     * @type {boolean}
     * @memberof RuleView
     */
    readonly archived: boolean;
    /**
     * Rule status
     * @type {string}
     * @memberof RuleView
     */
    readonly status?: string;
    /**
     * Rule type.
     * @type {string}
     * @memberof RuleView
     */
    readonly rule_type: string;
    /**
     * User-facing Unique identifier of the rule.
     * @type {string}
     * @memberof RuleView
     */
    readonly key: string;
    /**
     * User-facing name of the rule.
     * @type {string}
     * @memberof RuleView
     */
    readonly name?: string;
    /**
     * Additional context of the rule
     * @type {string}
     * @memberof RuleView
     */
    readonly description?: string;
    /**
     * The Key of the Flag this rule belongs to
     * @type {string}
     * @memberof RuleView
     */
    readonly flag_key: string;
    /**
     * The name of the Flag this rule belongs to
     * @type {string}
     * @memberof RuleView
     */
    readonly flag_name: string;
    /**
     * The status of the Flag this rule belongs to
     * @type {string}
     * @memberof RuleView
     */
    readonly flag_status: string;
    /**
     * The group that this rule belongs to
     * @type {string}
     * @memberof RuleView
     */
    readonly group_id?: string;
    /**
     * Timestamp when the rule is last updated
     * @type {Date}
     * @memberof RuleView
     */
    readonly updated_time: Date;
    /**
     * Link to self
     * @type {string}
     * @memberof RuleView
     */
    readonly url?: string;
}

export function RuleViewFromJSON(json: any): RuleView {
    return RuleViewFromJSONTyped(json, false);
}

export function RuleViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'project_id': json['project_id'],
        'enabled': json['enabled'],
        'archived': json['archived'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'rule_type': json['rule_type'],
        'key': json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'flag_key': json['flag_key'],
        'flag_name': json['flag_name'],
        'flag_status': json['flag_status'],
        'group_id': !exists(json, 'group_id') ? undefined : json['group_id'],
        'updated_time': (new Date(json['updated_time'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function RuleViewToJSON(value?: RuleView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


